module.exports = __webpack_public_path__ + "static/media/icon_zacktake.07f24728.png";